




























import { AvatarSize } from '@getaccept/lib-ui';
import { ChatHelper } from '@getaccept/lib-shared/src/chat/helpers/chat.helper';
import ChatMessageOther from '@getaccept/lib-shared/src/chat/components/ChatMessageOther.vue';
import ChatMessageSender from '@getaccept/lib-shared/src/chat/components/ChatMessageSender.vue';
import ChatTimestamp from '@getaccept/lib-shared/src/chat/components/ChatTimestamp.vue';
import type { ChatComment } from '@getaccept/lib-shared/src/chat/types/chat-comment';
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
  components: {
    ChatMessageSender,
    ChatMessageOther,
    ChatTimestamp,
  },
  props: {
    comment: {
      type: Object as PropType<ChatComment>,
      required: true,
    },
    comments: {
      type: Array as PropType<ChatComment[]>,
      required: true,
    },
    recipients: {
      type: Array as PropType<SigningPageRecipient[]>,
      required: true,
    },
    sender: {
      type: Object as PropType<SigningPageUser>,
      required: true,
    },
    recipientId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const showMessageTimestamp = ref(false);

    const clickOutside = () => {
      toggleMessageTimestamp(false);
    };

    const toggleMessageTimestamp = (show: boolean) => {
      showMessageTimestamp.value = show;
    };

    const name = computed((): string =>
      ChatHelper.getFullname(props.comment, props.sender, props.recipients)
    );
    const thumbUrl = computed((): string =>
      ChatHelper.getThumbUrl(props.comment, props.recipients, props.sender)
    );
    const date = computed((): string => ChatHelper.date(props.comment.createdAt));
    const time = computed((): string => ChatHelper.time(props.comment.createdAt));
    const fullTimestamp = computed((): string => ChatHelper.fullTimestamp(props.comment.createdAt));
    const showTimestamp = computed((): boolean =>
      ChatHelper.showTimestamp(previousComment.value, props.comment.createdAt)
    );
    const previousComment = computed(
      (): ChatComment => ChatHelper.getPreviousComment(props.comment, props.comments)
    );
    const nextComment = computed(
      (): ChatComment => ChatHelper.getNextComment(props.comment, props.comments)
    );
    const lastComment = computed((): ChatComment => ChatHelper.getLastComment(props.comments));
    const isLastCommentInMonologue = computed((): boolean =>
      ChatHelper.isLastCommentInMonologue(props.comment, lastComment.value.id, nextComment.value)
    );
    const isFirstCommentInMonologue = computed((): boolean =>
      ChatHelper.isFirstCommentInMonologue(previousComment.value, props.comment)
    );
    const isFirstCommentInBlock = computed((): boolean =>
      ChatHelper.isFirstCommentInBlock(previousComment.value, props.comment)
    );
    const isByActiveRecipient = computed((): boolean => {
      if (props.comment.userId) {
        return false;
      }
      return ChatHelper.isByActiveRecipient(props.comment, props.recipientId);
    });

    return {
      ChatHelper,
      AvatarSize,
      showMessageTimestamp,
      clickOutside,
      toggleMessageTimestamp,
      name,
      thumbUrl,
      date,
      time,
      fullTimestamp,
      showTimestamp,
      previousComment,
      nextComment,
      lastComment,
      isLastCommentInMonologue,
      isFirstCommentInMonologue,
      isFirstCommentInBlock,
      isByActiveRecipient,
    };
  },
});
